import { Component, input } from '@angular/core';
import { Questionnaire } from '../../core/models/questionnaire/questionnaire.model';
import { QuestionComponent } from "../../feedback/question/question.component";
import { QuestionnaireResponse } from '../../core/models/questionnaire/questionnaire-response.model';

@Component({
  selector: 'cwo-embeded-questionnaire-form',
  standalone: true,
  imports: [QuestionComponent],
  templateUrl: './embeded-questionnaire-form.component.html',
  styleUrl: './embeded-questionnaire-form.component.scss'
})
export class EmbededQuestionnaireFormComponent {
  questionnaire = input<Questionnaire | undefined>();

  responseFromQuestion(id: string) {
    return this.questionnaire()?.responses[id] ?? {};
  }


  responseChanged(id: string, response: QuestionnaireResponse) {
    this.questionnaire()!.responses[id] = response;
  }

  
  constructor() { }
}
